import type { DestinationId } from "./destinations";

/**
 * Lien d'une carte de rubrique de l'accueil : une destination, ou une action
 * propre à l'accueil (`findArtwork` ouvre la recherche d'une œuvre).
 */
export type HomeLinkId = DestinationId | "findArtwork";
export type HomeLink = { id: HomeLinkId; labelKey: string; label: string };

export const DATA_LINKS: HomeLink[] = [
  {
    id: "artworkNew",
    labelKey: "bo.home.data.addArtwork",
    label: "Ajouter une œuvre",
  },
  {
    id: "artworkSearch",
    labelKey: "bo.home.data.searchArtwork",
    label: "Rechercher une œuvre",
  },
  {
    // L'export se fait depuis la fiche : on y accède par une recherche.
    id: "findArtwork",
    labelKey: "bo.home.data.exportArtwork",
    label: "Exporter une œuvre",
  },
  {
    id: "importArtworks",
    labelKey: "bo.home.data.import",
    label: "Importer des données",
  },
];

export const WEBSITE_LINKS: HomeLink[] = [
  {
    id: "selections",
    labelKey: "bo.home.website.selections",
    label: "Sélections d’oeuvres",
  },
  { id: "eshop", labelKey: "bo.home.website.eshop", label: "E-commerce" },
  {
    id: "catalogueRaisonne",
    labelKey: "bo.home.website.catalogue",
    label: "Site catalogue Raisonné",
  },
  {
    id: "authentications",
    labelKey: "bo.home.website.authentications",
    label: "Authentifications",
  },
];

/**
 * Contacts = collectionneurs tant que le module Contacts n'existe pas
 * (« Créer une liste de contact » attendra ce module).
 */
export const CONTACT_LINKS: HomeLink[] = [
  {
    id: "collectorNew",
    labelKey: "bo.home.contacts.new",
    label: "Enregistrer un contact",
  },
  {
    id: "collectorSearch",
    labelKey: "bo.home.contacts.search",
    label: "Rechercher un contact",
  },
];
